import { render, staticRenderFns } from "./CosignerIncomeContainer.vue?vue&type=template&id=7d56e485&"
import script from "./CosignerIncomeContainer.vue?vue&type=script&lang=js&"
export * from "./CosignerIncomeContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports